import React from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import Layout from "../components/layout"
import ProjectLinks from "../components/projectlinks"
import Template from "../projects/template"
import Top from "../images/projecttop.svg"
import Bottom from "../images/projectbottom.svg"
import Bg from "../images/windowbg.svg"

const Background = styled(Bg)`
  width: 100%;
  height: 100vh;
  position: absolute;
`
const WindowTop = styled(Top)`
  width: 100%;
  max-width: 100vw;
  height: 517px;
  transform-origin: center bottom;
  transform: scale(0.8, 0.65);
  position: absolute;
  overflow: visible;
  top: -435.58px;
  z-index: 8;
  @media (max-width: 1200px) {
  }
  @media (max-width: 992px) {
    transform: scale(0.7, 0.55);
  }
  @media (max-width: 760px) {
    transform: scale(0.55, 0.4);
    top: -445.58px;
  }
  @media (max-width: 480px) {
    transform: scale(0.5, 0.3);
  }
`
const WindowBottom = styled(Bottom)`
  bottom: -58px;
  width: 100%;
  max-width: 100vw;
  height: 57px;
  transform-origin: center top;
  position: absolute;
  overflow: visible;
  transform: scale(0.8, 0.65);
  @media (max-width: 1200px) {
  }
  @media (max-width: 992px) {
    transform: scale(0.75, 0.55);
  }
  @media (max-width: 760px) {
    transform: scale(0.55, 0.4);
  }
  @media (max-width: 480px) {
    transform: scale(0.5, 0.3);
  }
`
const ProjDiv = styled.div`
  position: relative;
  top: 5%;
  width: 95%;
  height: 80vh;
  max-width: 1000px;

  @media (max-width: 992px) {
    top: 0%;
    height: 83vh;
  }
  @media (max-width: 760px) {
  }
  @media (max-width: 480px) {
    height: 85vh;
  }
`

const Container = styled.div`
  width: 100%;
  margin: 0;
  height: 100vh;
  padding: 0 calc((100vw - 1200px) / 2);
  display: flex;
  background: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

const Project = ({ children }) => (
  <Layout>
    <Background />
    <Container>
      <ProjDiv>
        <FlexNav>
          <ProjectNav to="/">{"< Home"}</ProjectNav>
          <ProjectNav>
            Projects
            <Dropdown>
              <ProjectLinks />
            </Dropdown>
          </ProjectNav>
        </FlexNav>

        <WindowTop></WindowTop>
        <Template>{children}</Template>
        <WindowBottom />
      </ProjDiv>
    </Container>
  </Layout>
)
export default Project

const ProjectNav = styled(Link)`
  font-style: normal;
  font-weight: 450;
  font-size: 18px;

  text-transform: uppercase;
  color: black;
  text-decoration: none;
  padding: 0px 7px;
  :hover {
    text-decoration: underline;
    color: #44cc2e;
  }
`
const Dropdown = styled.div`
  display: none;
  width: 220px;
  height: 0px;
  border: 1px solid #44cc2e;
  border-radius: 5px;
  position: absolute;
  top: 100%;
  z-index: 10;
  left: 45%;
  transition: height 1s ease;
  background: rgba(129, 129, 129, 0.95);
  @keyframes rotateY {
    0% {
      transform: rotateY(90deg);
    }
    80% {
      transform: rotateY(-10deg);
    }
    100% {
      transform: rotateY(0);
    }
  }
  ${ProjectNav}:hover & {
    display: block;
    animation: rotateY 300ms ease-in-out forwards;
    transform-origin: top center;
    height: auto;
  }
  @media (max-width: 768px) {
    width: 150px;
    left: 30%;
  }
`
const FlexNav = styled.div`
  display: flex;
  position: absolute;
  z-index: 10;
  top: -40px;
  left: 35px;
  @media (max-width: 992px) {
    top: -22px;
    left: 32px;
  }
  @media (max-width: 768px) {
    top: -8px;
    left: 30px;
  }
  @media (max-width: 480px) {
    top: 7px;
    left: 20px;
  }
`
